import { useCallback } from 'react';
import { cloneDeep } from 'lodash';

export const useHandlers = ({
  setIsMenuOpened,
  setSelectedItem,
  items,
  setPersistentItems,
  setLeaveMenuOpen,
  isMenuOpened,
  selectedItem,
}) => {
  const handleFormulaClick = useCallback(
    (item) => {
      if (isMenuOpened) {
        if (item?.tool === selectedItem?.tool) {
          setIsMenuOpened(false);
          setPersistentItems(null);
          setSelectedItem(null);
          return;
        }
        setLeaveMenuOpen(true);
      }
      const newPersistentItems = cloneDeep(items);
      setPersistentItems(newPersistentItems);
      setSelectedItem(item);
      setIsMenuOpened(true);
    },
    [
      isMenuOpened,
      items,
      selectedItem,
      setIsMenuOpened,
      setLeaveMenuOpen,
      setPersistentItems,
      setSelectedItem,
    ]
  );

  return {
    handleFormulaClick,
  };
};
